import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const achievementsApi = createApi({
    reducerPath: 'achievementsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/achievements",
    }),
    tagTypes: ["Achievements"],
    endpoints: (builder) => ({
        getMyAchievement: builder.query({
            query: () => ({
                method: "GET",
                url: `/me`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["Achievements"]
        }),
        getMyAchievementBadges: builder.query({
            query: () => ({
                method: "GET",
                url: `/badges`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["Achievements"]
        }),


    }),
})

export const {
    useGetMyAchievementQuery,
    useGetMyAchievementBadgesQuery
} = achievementsApi;